import { MenuFooterIcon } from '@/components/printMenu/MenuFooterIcon'
import type { MenuFooterStatement } from '@/content/printMenu/menuFooterStatements'

type MenuFooterProps = {
  statement: MenuFooterStatement
}

export function MenuFooter({ statement }: MenuFooterProps) {
  return (
    <footer className="menu-footer shrink-0 px-[10mm] py-[7mm]">
      <div className="menu-footer-quote mx-auto flex w-full items-center justify-center gap-2">
        <MenuFooterIcon name={statement.icon} className="shrink-0 text-primary" />
        <p className="min-w-0 shrink font-sans text-[length:var(--menu-fs-footer)] leading-none whitespace-nowrap text-muted">
          {statement.text}
        </p>
      </div>
    </footer>
  )
}
